import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewCategoriesAdminQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewCategoriesAdminQuery = { __typename?: 'query_root', plan_review_categories: Array<{ __typename?: 'plan_review_categories', id: any, jurisdiction_id: any, code: string, name: string, ai_guidance?: string | null, sort_order: number, active: boolean, plan_review_requirements_aggregate: { __typename?: 'plan_review_requirements_aggregate', aggregate?: { __typename?: 'plan_review_requirements_aggregate_fields', count: number } | null } }> };


export const GetPlanReviewCategoriesAdminDocument = gql`
    query getPlanReviewCategoriesAdmin($jurisdictionId: uuid!) {
  plan_review_categories(
    where: {jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: [{sort_order: asc}, {name: asc}]
  ) {
    id
    jurisdiction_id
    code
    name
    ai_guidance
    sort_order
    active
    plan_review_requirements_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewCategoriesAdminQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewCategoriesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewCategoriesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewCategoriesAdminQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetPlanReviewCategoriesAdminQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables> & ({ variables: GetPlanReviewCategoriesAdminQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables>(GetPlanReviewCategoriesAdminDocument, options);
      }
export function useGetPlanReviewCategoriesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables>(GetPlanReviewCategoriesAdminDocument, options);
        }
export function useGetPlanReviewCategoriesAdminSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables>(GetPlanReviewCategoriesAdminDocument, options);
        }
export type GetPlanReviewCategoriesAdminQueryHookResult = ReturnType<typeof useGetPlanReviewCategoriesAdminQuery>;
export type GetPlanReviewCategoriesAdminLazyQueryHookResult = ReturnType<typeof useGetPlanReviewCategoriesAdminLazyQuery>;
export type GetPlanReviewCategoriesAdminSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewCategoriesAdminSuspenseQuery>;
export type GetPlanReviewCategoriesAdminQueryResult = Apollo.QueryResult<GetPlanReviewCategoriesAdminQuery, GetPlanReviewCategoriesAdminQueryVariables>;